import { ChangeDetectorRef, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { BaseTooltipComponent } from '../base-tooltip/base-tooltip.component';

@Component({
  selector: 'boi-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent extends BaseTooltipComponent {
  @Input() public tooltipName: string;
  @Input() public text: string;
  @Input() public tooltipPosition: 'right' | 'left' = 'right';
  @Input() public showTooltip = true;
  @Input() public tooltipLabel: string;
  @Input() public tooltipClass = '';

  @ViewChild('toolTip') toolTip: TooltipDirective;

  constructor(renderer: Renderer2, cdr: ChangeDetectorRef) {
    super(renderer, cdr);
  }

  public toggle(anchor: any, event: TouchEvent | MouseEvent): void {
    super.toggle(this.toolTip, anchor, event);
    const title = anchor.getAttribute('title');
    if (title) {
      anchor.setAttribute('data-title', title);
      anchor.removeAttribute('title');
    }
  }
}
